/* src/app/leave-request/presenters/leave-request.component.scss */
body#themeTag :host ::ng-deep p-cellEditor {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-header {
  height: 5.75em;
}
body#themeTag :host ::ng-deep .fc-center > div {
  display: flex;
}
body#themeTag :host ::ng-deep .fc-center > div > * {
  padding: 0 1rem;
}
body#themeTag :host ::ng-deep .p-dialog-content form {
  display: flex;
}
body#themeTag :host ::ng-deep .p-dialog-content form > div {
  padding: 1rem;
}
body#themeTag :host ::ng-deep .p-dialog-content .p-dropdown {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-dialog-content .p-inputtext {
  font-size: 1rem;
  height: 2rem;
}
body#themeTag :host ::ng-deep .p-dialog-content .p-calendar.p-calendar-w-btn {
  display: flex;
}
body#themeTag :host ::ng-deep .btn.btn-link {
  padding: 0;
}
body#themeTag :host ::ng-deep .clearable-date-filter {
  width: unset;
  padding: 0 0.75em;
  height: 2em;
}
body#themeTag :host ::ng-deep .sticky-table-container {
  overflow: auto !important;
  max-height: 510px;
}
body#themeTag :host ::ng-deep #calendar-container {
  min-width: 20rem;
}
body#themeTag :host ::ng-deep .tabulator-col-title {
  height: 1.5rem;
}
body#themeTag :host ::ng-deep .fc-toolbar button .fc-showAll-button {
  color: #ffffff;
  background: #337ab7;
  border: 1px solid #337ab7;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  transition:
    background-color 0.15s,
    border-color 0.15s,
    box-shadow 0.15s;
  border-radius: 4px;
}
body#themeTag :host ::ng-deep .fc-toolbar button .fc-showAll-button:enabled:hover {
  background: #285f8f;
  color: #ffffff;
  border-color: #285f8f;
}
/*# sourceMappingURL=leave-request.component.css.map */
